import type { Button as CmsButton, ButtonIcon } from "@/lib/directus-schema";

type Rel<T> = T | string | null | undefined;

function asObject<T extends object>(value: Rel<T>): T | null {
    return value && typeof value === "object" ? value : null;
}

function iconKey(icon: Rel<ButtonIcon>): string | undefined {
    return asObject(icon)?.key ?? undefined;
}

export type UiButtonData = {
    label: string;
    subtitle?: string;
    iconLeft?: string;
    iconRight?: string;
};

export function mapCmsButton(buttonRel: Rel<CmsButton>): UiButtonData | null {
    const button = asObject(buttonRel);
    if (!button) return null;

    return {
        label: button.label ?? "",
        subtitle: button.subtext ?? undefined,
        iconLeft: iconKey(button.icon_left),
        iconRight: iconKey(button.icon_right),
    };
}
